var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1813_64191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.61 4H13.2C9.78 4 7 6.78 7 10.2V48C7 51.42 9.78 54.2 13.2 54.2H45.61C48.15 54.2 50.2 52.14 50.2 49.61V8.59C50.2 6.06 48.14 4 45.61 4Z",
    fill: "url(#paint0_linear_1813_64191)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.71 43.6H50.2V51C50.2 53.46 48.1 54.2 45.61 54.2H12.71C9.6 54.2 7 51.8 7 48.9C7 46 9.61 43.6 12.71 43.6Z",
    fill: "#2C3E7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.62 4V19.6C34.62 20.2 34.62 20.5 34.81 20.7C35 20.7 35.38 20.7 36.04 20.4L39.17 19.1H40.12L43.25 20.4C44.01 20.7 44.29 20.8 44.48 20.7C44.67 20.7 44.67 20.3 44.67 19.6V4H34.61H34.62Z",
    fill: "#2C3E7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.13 28.7399C13.13 27.8199 13.88 27.0699 14.8 27.0699H32.86C33.78 27.0699 34.53 27.8199 34.53 28.7399C34.53 29.6599 33.78 30.4099 32.86 30.4099H14.8C13.88 30.4099 13.13 29.6599 13.13 28.7399Z",
    fill: "#2C3E7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.88 33.92C13.96 33.92 13.21 34.67 13.21 35.59C13.21 36.51 13.96 37.26 14.88 37.26H26.17C27.09 37.26 27.84 36.51 27.84 35.59C27.84 34.67 27.09 33.92 26.17 33.92H14.88Z",
    fill: "#2C3E7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.57 47.23H12.25C11.36 47.23 10.63 47.98 10.63 48.9C10.63 49.82 11.36 50.57 12.25 50.57H46.57V47.23Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1813_64191",
    x1: 19.55,
    y1: -5.78,
    x2: 34.17,
    y2: 49.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7DBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1813_64191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.2,
    height: 50.2,
    fill: "white",
    transform: "translate(7 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBook);
export default __webpack_public_path__ + "static/media/icon_book.81ab8fb6405dcff98c037930a8cd2eb7.svg";
export { ForwardRef as ReactComponent };